// src/reducers/hazardReducer.js
// Manages state for hazardous site alerts triggered via FCM

const INITIAL_STATE = {
  active: false,
  title: null,
  body: null,
  data: null, // any extra payload
  timestamp: null
};

export const HAZARD_SET = 'hazard/SET';
export const HAZARD_CLEAR = 'hazard/CLEAR';

export default function hazardReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case HAZARD_SET: {
      const { title, body, data } = action.payload || {};
      return {
        ...state,
        active: true,
        title: title || 'Hazardous!!!',
        body: body || '',
        data: data || null,
        timestamp: Date.now()
      };
    }
    case HAZARD_CLEAR:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
}
